var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
'component',
'component__icon',
_vm.size ? ("component__icon--" + _vm.size) : '',
_vm.theme ? ("component__icon--" + _vm.theme) : ''
]},[_c('v-icon',{attrs:{"name":_vm.iconName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }